// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1sd6y","row":"Node_row__1OO2N","label":"Node_label__P9ORT","footer":"Node_footer__3jEFK"};